import { GET_SUCCESSES, GET_ERRORS, CLEAR_SUCCESSES } from "../actions/types";

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_SUCCESSES:
      return action.payload;
    case GET_ERRORS:
      return {};
    case CLEAR_SUCCESSES:
      return {
        ...state
      };
    default:
      return state;
  }
}
